<template>
  <div class="list">
    <div class="header">
      <div class="l" />
      <div class="r">
        <el-input
          v-model="mobilePhone"
          placeholder="请输入手机号"
          @keyup.enter.native="getList()"
        >
          <el-button
            slot="append"
            type="primary"
            @click="getList()"
          >
            搜索
          </el-button>
        </el-input>
        <el-button
          type="primary"
          @click="goCreatOrEdit"
        >
          新建账号
        </el-button>
      </div>
    </div>
    <data-table
      :data="tabelData"
      :pagination="true"
      :table-column="tableColumn"
      @changeBypagination="tableHandle"
      @buttonClick="buttonClick"
    />
  </div>
</template>

<script>
import axClient from '@/services';
import dataTable from '@/components/common/dataTable.vue';
import types, { identityInformation } from '@/config';

// @ is an alias to /src

export default {
  name: 'Home',
  components: {
    dataTable,
  },
  data() {
    return {
      value: '',
      mobilePhone: '',
      tabelData: {},
      pageNum: 1,
      pageSize: 10,
      tableColumn: [
        {
          key: 'loginName',
          label: '用户名',
          width: 'auto',
          dataType: 'text',
        },
        {
          key: 'realName',
          label: '真实姓名',
          width: '80px',
          dataType: 'text',
        },
        {
          key: 'mobilePhone',
          label: '手机号码',
          width: 'auto',
          dataType: 'text',
        },
        {
          key: 'identityType',
          label: '身份信息',
          width: '80px',
          dataType: 'function',
          renderProps: '',
          render: (key) => identityInformation.filter((item) => item.value === key),
        },
        {
          key: 'identityValid',
          label: '状态',
          width: '80px',
          dataType: 'component',
          renderProps: { [types.INDENTITY_VALID_ENABLE]: '启用', [types.INDENTITY_VALID_DISABLE]: '禁用', successKey: types.INDENTITY_VALID_ENABLE },
          render: () => 'status',
        },
        {
          key: 'identityCreateTime',
          label: '创建时间',
          width: 'auto',
          dataType: 'time',
        },
        {
          key: 'control',
          label: '操作',
          width: 'auto',
          dataType: 'component',
          renderProps: [
            {
              text: '启用', renderKey: types.INDENTITY_VALID_DISABLE, renderProp: 'identityValid', type: 'success', eventIndex: 0, disableKey: null,
            },
            {
              text: '禁用', renderKey: types.INDENTITY_VALID_ENABLE, renderProp: 'identityValid', eventIndex: 0, disableKey: null,
            },
            {
              text: '编辑', renderKey: null, type: 'primary', eventIndex: 1, disableKey: null,
            },
            {
              text: '查看', renderKey: null, type: 'info', eventIndex: 2, disableKey: null,
            },
          ],
          render: () => 'buttons',
        },
      ],
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    // 获取列表
    async getList(num = 1) {
      this.pageNum = num;
      const result = await axClient.account.getList({
        mobilePhone: this.mobilePhone,
        pageSize: this.pageSize,
        pageNum: this.pageNum,
      });
      const { pageNum, pageSize, total } = result;
      this.tabelData = {
        pageNum,
        pageSize,
        total,
        list: result.list,
      };
    },
    // 禁用/启用 账号
    confirmDialog(item) {
      this.$confirm('确定禁用/启用该账号？', '禁用/启用账号', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        showClose: false,
        type: 'error',
      }).then(async() => {
        const { identityId, identityValid } = item;
        const data = await axClient.account.updateEntityValid(
          {
            identityId,
            identityValid: identityValid === types.INDENTITY_VALID_ENABLE
              ? types.INDENTITY_VALID_DISABLE : types.INDENTITY_VALID_ENABLE,
          },
        );
        if (data) {
          this.$message.success('启用/禁用成功');
          this.getList();
        }
      });
    },
    // 跳转到详情
    goDetails(item) {
      this.$router.push({ name: 'AccountDetails', params: { id: item.identityId } });
    },
    // 跳转到新增/编辑
    goCreatOrEdit(item) {
      this.$router.push({ name: 'AccountCreate', params: { id: item.identityId } });
    },
    // table 传递过来的按钮点击
    buttonClick(type, item) {
      switch (type) {
        case 0:
          this.confirmDialog(item);
          break;
        case 1:
          this.goCreatOrEdit(item);
          break;
        case 2:
          this.goDetails(item);
          break;
        default:
          break;
      }
    },
    // table 改变 pagination 时间
    tableHandle(pageNum, pageSize) {
      this.pageNum = pageNum;
      this.pageSize = pageSize;
      this.getList(pageNum);
    },
  },
};
</script>
<style lang="scss" scoped>

</style>
